/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de diffusion du pack souscrit (rabattu depuis le vocabulaire de la base — limite max/min, consommation → LIMITED ; illimite → UNLIMITED)
 */
export const typeDiffusionPackSchema = z.enum(["LIMITED", "UNLIMITED"]).describe("Type de diffusion du pack souscrit (rabattu depuis le vocabulaire de la base — limite max/min, consommation → LIMITED ; illimite → UNLIMITED)")